export default {
    default: 'appointments',
    detail: 'appointments/:id',
    delete: 'appointments/:id',
    deleteNormal: 'appointments/:id/normal',
    deleteRecurrence: 'appointments/:id/occurrences/:date',
    detailRecurrence: 'appointments/:id/occurrences/:date',
    configuration: 'appointments/configs',
    detailFullInfo: 'appointments/:id/full',
    properties: 'appointments/:id/properties',
    persons: 'appointments/:id/persons',
    comments: 'appointments/:id/comments',
    histories: 'appointments/:id/histories',
    quickUpdate: 'appointments/:id/exceptions/normal-dragdrop',
    updateResource: 'appointments/:id/normal-dragdrop',
    updateException: 'appointments/:masterid/exceptions',
    exceptions: 'appointments/:masterid/exceptions',
    exceptionsFull: 'appointments/:masterid/exceptions/full',
    paging: 'appointments/paging',
    query: 'appointments/query',
    getSuggestPlace: 'appointments/suggest-place',
    getAllSuggestPlace: 'appointments/suggest-all-places',
    getAgendaPriceEstimate: 'appointments/price-estimate',
    getAgendaOptimizeFilterUsers: "appointments/optimize-filterusers",
    getAgendaDetailSeries: "appointments/:id/preview",
	getAppointmentContextMenu: "appointments/context-menus",
	postAppointmentConfirmation: "appointments/:agendaId/confirmations",
	postAppointmentNewConfirmation: "appointments/:agendaId/new-confirmations",
	postAppointmentGenerateConfirmation: "appointments/:agendaId/generate-confirmations",
	postAppointmentInitialConfirmation: "appointments/:agendaId/initial-confirmation",
	postAppointmentNewConfirmationSMS: "appointments/:agendaId/new-confirmation-sms",
	postAppointmentSaveConfirmation: "appointments/:agendaId/save-confirmations",
	postAppointmentNewSaveConfirmation: "appointments/:agendaId/new-save-confirmations",
	postAppointmentNewMailConfirmation: "appointments/:agendaId/new-mail-confirmation",
	postAppointmentNewSMSConfirmation: "appointments/:agendaId/new-sms-confirmation",
    postAppointmentEditMailConfirmation: "appointments/:agendaId/edit-mail-confirmation",
    postAppointmentEditSMSConfirmation: "appointments/:agendaId/edit-sms-confirmation",
    getNextStatusAppointment: "appointments/next-status/:code",
    getNextStatusesAppointment: "appointments/next-statuses/:code",
	postChangeStatusAppointment: "appointments/change-status/:agendaId",
    postAppointmentEditConfirmation: "appointments/:agendaId/edit-confirmation",
    postAppointmentEditConfirmationSMS: "appointments/:agendaId/edit-confirmation-sms",
    agendaGetTasks: 'appointments/agenda-tasks',
    postAgendaLoadFromTask: 'appointments/load-from-task/:taskId',
	postAgendaCreateFromTask: 'appointments/create-from-task/:taskId',
	initOpenAppointment: 'appointments/open-appointments/default',
    createOpenAppointment: 'appointments/create-open-appointments',
    deleteOpenAppointment: 'appointments/open-appointments/delete',
    smartSuggestion: 'appointments/smart-suggestion',
    token2Condition: 'appointments/populate-condition/token2Detail',
    condition2Token: 'appointments/populate-condition/detail2Token',
    search: 'appointments/search',
    superAppointment: 'appointments/superAppointment',
    superAppointmentDetail: 'appointments/superAppointment-detail',
    nextViewingsByProperty: 'appointments/property/:objectId/next-viewings',
    basicAppointment: 'appointments/:id/basic'
}
